/* eslint-disable prettier/prettier */
const BREAKPOINTS_DEVICES = {
  MOBILE: 320,
  MOBILEBIG: 480,
  PHABLET: 660,
  TABLET: 768,
  DESKTOP: 960,
  WIDE: 1366
};

const FOOTER_DATA = {
  MENUS: [
    { href: '/contact-us', name: 'Contact' },
    { href: '/terms-conditions', name: 'Terms & Conditions' },
    { href: '/privacy', name: 'Privacy Policy' },
    { href: '/cookies', name: 'Cookie Policy' }
  ],
  COPYRIGHT: '© 2022 Example project. All rights reserved.'
};

const HEADER_MENUS = [
  {
    name: 'News',
    href: '/news'
  },
  {
    name: 'Contact',
    href: '/contact-us'
  }
];

const SOCIAL_DATA = [
  {
    href: 'https://www.facebook.com/example-project/',
    name: 'facebook',
    socialClass: 'facebook-f'
  },
  {
    href: 'https://twitter.com/example-project',
    name: 'twitter',
    socialClass: 'twitter'
  },
  {
    href: 'https://instagram.com/example-project',
    name: 'instagram',
    socialClass: 'instagram'
  }
];

const imageSizes = {
  largeWidths: {
    '320w': {
      r: {
        width: 320
      }
    },
    '480w': {
      r: {
        width: 480
      }
    },
    '660w': {
      r: {
        width: 660
      }
    },
    '768w': {
      r: {
        width: 768
      }
    },
    '960w': {
      r: {
        width: 960
      }
    },
    '1280w': {
      r: {
        width: 1280
      }
    },
    '1920w': {
      r: {
        width: 1920
      }
    }
  },
  standardWidths: {
    '320w': {
      r: {
        width: 320
      }
    },
    '480w': {
      r: {
        width: 480
      }
    },
    '660w': {
      r: {
        width: 660
      }
    },
    '768w': {
      r: {
        width: 768
      }
    },
    '960w': {
      r: {
        width: 960
      }
    },
    '1280w': {
      r: {
        width: 1280
      }
    }
  },
  '3:2': {
    '320w': {
      r: {
        width: '320',
        height: '213'
      }
    },
    '480w': {
      r: {
        width: '480',
        height: '320'
      }
    },
    '660w': {
      r: {
        width: '660',
        height: '440'
      }
    },
    '768w': {
      r: {
        width: '768',
        height: '512'
      }
    },
    '1024w': {
      r: {
        width: '1024',
        height: '683'
      }
    },
    '1366w': {
      r: {
        width: '1366',
        height: '911'
      }
    }
  },
  '16:9': {
    '320w': {
      r: {
        width: 320,
        height: 180
      }
    },
    '480w': {
      r: {
        width: 480,
        height: 270
      }
    },
    '660w': {
      r: {
        width: 660,
        height: 371
      }
    },
    '768w': {
      r: {
        width: 768,
        height: 432
      }
    },
    '960w': {
      r: {
        width: 960,
        height: 540
      }
    },
    '1280w': {
      r: {
        width: 1280,
        height: 720
      }
    }
  },
  squares: {
    '235w': {
      r: {
        width: '235',
        height: '235'
      }
    }
  }
};

const RESPONSIVE_IMAGE_CONFIG = process.env.BLAZE_DISABLE_RESPONSIVE_IMAGES === "true"
  ? null
  : {
    sizes: {
      socialMeta: {
        single: {
          r: {
            width: 1280
          }
        }
      },
      background: {
        single: imageSizes.largeWidths['1920w']
      },
      'card:portrait:grid--one:no-resize': {
        disabled: true
      },
      'card:portrait:grid--two:no-resize': {
        disabled: true
      },
      'card:portrait:grid--three:no-resize': {
        disabled: true
      },
      'card:portrait:grid--four:no-resize': {
        disabled: true
      },
      'card:landscape:grid--one:no-resize': {
        disabled: true
      },
      'card:landscape:grid--two:no-resize': {
        disabled: true
      },
      'card:landscape:grid--three:no-resize': {
        disabled: true
      },
      'card:landscape:grid--four:no-resize': {
        disabled: true
      },
      'card:landscape:grid--one:sidebar-card': {
        widths: {
          '320w': imageSizes['16:9']['320w'],
          '660w': imageSizes['16:9']['660w']
        },
        sizes: '(max-width: 960px) 40vw, 10vw'
      },
      'card:portrait:grid--two': {
        widths: imageSizes['3:2'],
        sizes: '(max-width: 768px) 100vw, (max-width: 1024px) 20vw, 15vw'
      },
      'card:portrait:grid--three': {
        widths: imageSizes['3:2'],
        sizes: '(max-width: 768px) 100vw, (max-width: 1024px) 20vw, 15vw'
      },
      'card:portrait:grid--four': {
        widths: imageSizes.standardWidths,
        sizes: '(max-width: 768px) 50vw, 25vw'
      },
      'card:landscape:grid--two': {
        widths: imageSizes.standardWidths,
        sizes: '(max-width: 768px) 40vw, 10vw'
      },
      'card:landscape:grid--one': {
        widths: imageSizes.standardWidths,
        sizes: '40vw'
      },
      // author on authors listing
      'card:landscape:grid--four:background__light card--image-vertical__center card--image-margin card--1third-image':
      {
        widths: imageSizes.squares,
        sizes: '30vw'
      },
      // featured on Technologies page
      'card:landscape:grid--one:background__pattern  card--large-title card--animated-image': {
        widths: imageSizes.standardWidths,
        sizes: '(max-width: 768px) 100vw, 40vw'
      },
      // featured on home
      'card:landscape:grid--one:background__pattern  card--large-title card--animated-image card--featured--no-badge':
      {
        widths: imageSizes.standardWidths,
        sizes: '(max-width: 768px) 100vw, 50vw'
      },
      // two on homepage
      'card:landscape:grid--two:1quarter-image': {
        widths: imageSizes.standardWidths,
        sizes: '(max-width: 768px) 100vw, 20vw'
      },
      // events on homepage
      'card:landscape:grid--two:background__border card--events card--image-right__1quarter-image':
      {
        widths: imageSizes.standardWidths,
        sizes: '(max-width: 768px) 100vw, 20vw'
      },
      // listings
      'card:landscape:grid--one:background__pattern card--image-right__1quarter-image': {
        widths: imageSizes.standardWidths,
        sizes: '(max-width: 768px) 100vw, 33vw'
      },
      // 'Related articles'
      'card:portrait:grid--four:background__pattern': {
        widths: imageSizes.standardWidths,
        sizes: '100vw'
      },
      // events listing
      'card:landscape:grid--one:background__border card--events card--image-right__1quarter-image':
      {
        widths: imageSizes.standardWidths,
        sizes: '(max-width: 768px) 100vw, 20vw'
      },
      // listing on channel page
      'card:landscape:grid--one:background__border card--1quarter-image': {
        widths: imageSizes.standardWidths,
        sizes: '(max-width: 768px) 100vw, 20vw'
      },
      // homepage featured carousel
      'card:hero:grid--one': {
        widths: imageSizes.largeWidths,
        sizes: '(max-width: 1920px) 100vw, 75vw'
      },
      // homepage tabs
      'card:portrait:grid--two:background__shadow-box card--product card--animated-image': {
        widths: imageSizes.standardWidths,
        sizes: '(max-width: 768px) 100vw, 50vw'
      },
      card: {
        widths: imageSizes.standardWidths,
        sizes: '100vw'
      },
      globalLightbox: {
        widths: imageSizes.standardWidths,
        sizes: '100vw'
      },
      image: {
        widths: imageSizes.standardWidths,
        sizes: '100vw'
      },
      carousel: {
        widths: {
          // 525w is wrong but will trigger srcset correctly
          '525w': {
            r: {
              height: 350
            }
          }
        },
        sizes: '100vw'
      }
    }
  };

export { BREAKPOINTS_DEVICES, FOOTER_DATA, HEADER_MENUS, SOCIAL_DATA, RESPONSIVE_IMAGE_CONFIG };
